import idLang from './entries/id_ID';

const AppLocale = {
  id: idLang,
};

export default AppLocale;
